DEBUG = false

eventToCode = ({ command, type, params }) ->
  command_str = "Backbone.Events.trigger("

  if window.__?.slidedeck?.id?
    command_str += "'slidedeck:" + window.__.slidedeck.id + ":#{command}'"
  else if window.__?.challenge?
    command_str += "'challenge:#{command}'"
  else
    command_str += "'#{command}'"

  if _.isArray(params) and params.length > 0
    command_str += ", #{JSON.stringify(params[0])}"

  command_str += ");"
  console.log("BACKBONE", command_str) if DEBUG

  command_str

runCommand = (params) ->
  if window.parent?.postMessage
    message = eventToCode(params)
    window.parent.postMessage(message, "*")

process = (command, next) ->
  if command?.type is "event"
    runCommand(command, null)
  else
    next command

module.exports = { process, type: "backbone_event" }
